import * as React from "react"

import { cn } from "../../lib/utils"
import { GLOBAL_MIN_DATE } from "../../constants/date"

const Input = React.forwardRef(
  ({ className, type, error, min, ...props }, ref) => {
    const resolvedMin = type === "date" && (min == null || min === "") ? GLOBAL_MIN_DATE : min

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-muted/50 disabled:text-foreground",
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive",
          error && "border-destructive ring-destructive focus-visible:ring-destructive",
          className
        )}
        ref={ref}
        aria-invalid={error ? "true" : undefined}
        min={resolvedMin}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
